import React from "react";
import { numbersData } from "./config";
import {
  Description,
  InnerContainer,
  MainContainer,
  Number,
  NumberContainer,
  Title,
  Container,
  VerticalLine,
} from "./styled.components";

const NumbersComponent = () => {
  return (
    <Container>
      <MainContainer>
        <InnerContainer>
          {numbersData.map((_item) => {
            return (
              <>
                <NumberContainer>
                  <Number>{_item.number}</Number>
                  <Title>{_item.name}</Title>
                  <Description>{_item.description}</Description>
                </NumberContainer>
                <VerticalLine />
              </>
            );
          })}
        </InnerContainer>
      </MainContainer>
    </Container>
  );
};
export default NumbersComponent;
